// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"786e9174","246":"30c1c600","485":"0ae44b16","614":"9762693f","659":"e3e49d0e","888":"d018dcb8","936":"1acbd07a"}[chunkId] + ".chunk.js";
};